import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DYNAMIC_FEATURE_KEY, DynamicState } from './dynamic.state';
import { GetObjectProperty, GetValueFromLocalStore } from 'src/app/shared/helpers/store-helper';

export const dynamicQuery = createFeatureSelector<DynamicState>(DYNAMIC_FEATURE_KEY);
export const uiDefinition = createSelector(dynamicQuery, (state: DynamicState) => state.uiDefinition);
export const presentation = createSelector(dynamicQuery, (state: DynamicState) => state.presentation);

const localStore = (state: DynamicState) => state.local;
const sessionStore = (state: DynamicState) => state.session;

export function GetStore(state: DynamicState, storeName: string) {
    if (storeName.toLowerCase() === 'local') return localStore(state);
    if (storeName.toLowerCase() === 'session') return sessionStore(state);
    return undefined;
}

export const getStoreData = (storeName: string, storeDataName: string, storeDataPath: string, storeDataChildNames: string[]) => createSelector(
    dynamicQuery,
    (state: DynamicState) => {
        switch (storeName.toLowerCase()) {
            case 'local':
                return GetValueFromLocalStore(state.local, storeDataPath ? `${storeDataName}.${storeDataPath}` : storeDataName, storeDataChildNames);
            case 'session':
                return GetObjectProperty(state.session, storeDataPath ? `${storeDataName}.${storeDataPath}` : storeDataName);
            default:
                console.warn(`Unknown store name: ${storeName}`);
                return null;
        }
    }
);

export const getActions = createSelector(
    dynamicQuery,
    (state: DynamicState) => state.actions
);

export const getAction = (name: string, storeDataChildNames: string[]) => createSelector(
    dynamicQuery,
    (state: DynamicState) => {
        const action = state.actions.find(c => (c.name as string).toLowerCase() === name.toLowerCase() && c.path.toLowerCase() === storeDataChildNames.join('.').toLowerCase());
        if (!action) {
            throw new Error(`Action '${name}' nicht gefunden im Store.`);
        }
        return action;
    }
);

